/**
 * Работа с числами
 * @packageDocumentation
 */

/**
 * Посчитать процент от числа (сколько процентов составляет part от full)
 * @param part - первое число
 * @param full - второе число
 * @param precision - точность (колличество знаков после запятой)
 */
export const percentOfNumber = (part: '--' | number, full: number = 100, precision: number = 0): '--' | number => {
	if (part === '--') return part;

	let percent = (full * 1) ? part / full : 0;
	percent *= 100;

	// если десятичные знаки не выводятся и число при округлении может дать ноль, то округляем в большую сторону
	if (!precision && percent < 1) {
		percent = Math.round(percent * (Math.pow(10, 2))) / (Math.pow(10, 2));
	} else {
		percent = Math.round(percent * (Math.pow(10, precision))) / (Math.pow(10, precision));
	}

	return percent;
};

/**
 * Генерация псевдорандомного числа
 *
 * Детерменированная функция по параметру seed
 */
export const randomBySeed = (seed: number) => {
	let x = Math.sin(seed) * 10000;

	return x - Math.floor(x);
};
